"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINDING_SLUG_PREFIX = void 0;
exports.formatFindingSlug = formatFindingSlug;
exports.parseFindingSlug = parseFindingSlug;
exports.FINDING_SLUG_PREFIX = 'FINDING-';
function formatFindingSlug(findingNumber) {
    return `${exports.FINDING_SLUG_PREFIX}${findingNumber}`;
}
function parseFindingSlug(slug) {
    if (!slug.startsWith(exports.FINDING_SLUG_PREFIX)) {
        return null;
    }
    const rest = slug.slice(exports.FINDING_SLUG_PREFIX.length);
    if (!/^[1-9]\d*$/.test(rest)) {
        return null;
    }
    return Number.parseInt(rest, 10);
}
//# sourceMappingURL=finding-slug.js.map